module.exports = __webpack_public_path__ + "img/cmab_bayarea_e.30c0c406.jpg";